import { Settings, Duration, Info, DateTime as DateTime$1, Interval as Interval$1 } from 'luxon';
export { Duration } from 'luxon';

function _class_call_check$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties$3(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class$3(Constructor, protoProps, staticProps) {
    if (staticProps) _defineProperties$3(Constructor, staticProps);
    return Constructor;
}
var DateSettings = /*#__PURE__*/ function() {
    function DateSettings() {
        _class_call_check$3(this, DateSettings);
    }
    _create_class$3(DateSettings, null, [
        {
            key: "now",
            get: function get() {
                return Settings.now;
            },
            set: function set(now) {
                Settings.now = now;
            }
        },
        {
            key: "defaultZone",
            get: function get() {
                return Settings.defaultZone;
            },
            set: function set(zone) {
                Settings.defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return Settings.defaultLocale;
            },
            set: function set(locale) {
                Settings.defaultLocale = locale;
            }
        },
        {
            key: "systemTimeZone",
            get: function get() {
                return Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        }
    ]);
    return DateSettings;
}();

var DaysOfWeek;
(function(DaysOfWeek) {
    DaysOfWeek[DaysOfWeek["Sunday"] = 0] = "Sunday";
    DaysOfWeek[DaysOfWeek["Monday"] = 1] = "Monday";
    DaysOfWeek[DaysOfWeek["Tuesday"] = 2] = "Tuesday";
    DaysOfWeek[DaysOfWeek["Wednesday"] = 3] = "Wednesday";
    DaysOfWeek[DaysOfWeek["Thursday"] = 4] = "Thursday";
    DaysOfWeek[DaysOfWeek["Friday"] = 5] = "Friday";
    DaysOfWeek[DaysOfWeek["Saturday"] = 6] = "Saturday";
})(DaysOfWeek || (DaysOfWeek = {}));

var ALL_DAYS_OF_WEEK = [
    DaysOfWeek.Monday,
    DaysOfWeek.Tuesday,
    DaysOfWeek.Wednesday,
    DaysOfWeek.Thursday,
    DaysOfWeek.Friday,
    DaysOfWeek.Saturday,
    DaysOfWeek.Sunday
];
var MAXIMUM_DATE_MILLISECOND = 8640000000000000;

/* eslint-disable const-case/uppercase */ /**
 * @format dd LLLL yyyy
 * @example 22nd April 2021
 **/ var _DAY_TEXT_MONTH_YEAR = "dd LLLL yyyy";
/**
 * @format yyyy-LL
 * @example 2024-06
 **/ var _YEAR_MONTH_FORMAT = "yyyy-LL";
/**
 * @format yyyy
 * @example 2024
 **/ var _YEAR_FORMAT = "yyyy";
/**
 * @format LLLL yyyy
 * @example June 2024
 **/ var _MONTH_TEXT_FORMAT = "LLLL yyyy";
/**
 * @format yyyy-LL-dd
 * @example 2024-06-22
 **/ var _ISO_DATE = "yyyy-LL-dd";
/**
 * @format dd/LL/yyyy
 * @example 22/06/2024
 **/ var _DAY_DEFAULT_FORMAT = "dd/LL/yyyy";
/**
 * @format dd/LL/yy
 * @example 22/06/24
 **/ var _SHORT_YEAR_FORMAT = "dd/LL/yy";
/**
 * @format d LLL yyyy
 * @example 7 Dec 2018
 **/ var _DAY_TEXT_MONTH_YEAR_SHORT = "d LLL yyyy";
/**
 * @format dd LLL yyyy
 * @example 07 Dec 2018
 **/ var _DAY_TEXT_MONTH_YEAR_SHORT_ALIGN = "dd LLL yyyy";
/**
 * @format yyyyLLdd-hmma
 * @example 20240622-0832am
 **/ var _TEST_DATE_FORMAT = "yyyyLLdd-hmma";
/**
 * @format d LLL yyyy h:mm a
 * @example 7 Dec 2018 8:32 AM
 **/ var _LONG_DATE_FORMAT = "d LLL yyyy h:mm a";
/**
 * @format dd/LL/yyyy, h:mm a
 * @example 22/06/2024, 8:32 AM
 **/ var _LONG_DATE_TIME_FORMAT = "dd/LL/yyyy, h:mm a";
/**
 * @format LL/dd/yyyy, h:mm a
 * @example 10/14/1983, 9:30:33 AM
 **/ var _LONG_DATE_TIME_FORMAT_MONTH_AHEAD = "LL/dd/yyyy, h:mm a";
/**
 * @format h:mm a dd/LL/yyyy
 * @example 8:32 AM 22/06/2024
 **/ var _LONG_DATE_TIME_FORMAT_REVERSED = "h:mm a dd/LL/yyyy";
/**
 * @format cccc Do LLLL
 * @example Thursday 8th July
 **/ var _LONG_DATE_WITHOUT_TIME = "cccc Do LLLL";
/**
 * @format ccc, dd/LL/yyyy
 * @example Thu, 22/06/2024
 **/ var _DATE_TIME_FORMAT_WITH_DAY_OF_WEEK = "ccc, dd/LL/yyyy";
/**
 * @format ccc, LL/dd/yyyy, HH:mm a
 * @example Thu, 12/25/2020, 08:32 AM
 **/ var _FULL_DATE_WEEKDAY_SHORT_MONTH_AHEAD = "ccc, LL/dd/yyyy";
/**
 * @format ccc
 * @example Friday
 **/ var _DAY_OF_WEEK_STRING = "cccc";
/**
 * @format ccc dd/LL/yyyy
 * @example Fri 22/06/2024
 **/ var _LONG_DATE_WITH_DAY = "ccc dd/LL/yyyy";
/**
 * @format ffff
 * @example Friday, June 22, 2024, 8:32 AM
 **/ var _LOCALIZED_DATE_TIME = "ffff";
/**
 * @format yyyyLLddHHmm
 * @example 202406220832
 **/ var _HL7_RESPONSE_DATE_FORMAT = "yyyyLLddHHmm";
/**
 * @format h:mm a
 * @example 8:32 AM
 **/ var _DEFAULT_TIME_FORMAT = "h:mm a";
/**
 * @format h:mm:ss a
 * @example 8:32:59 AM
 **/ var _LONG_TIME_FORMAT = "h:mm:ss a";
/**
 * @format hh:mm a
 * @example 08:32 AM
 **/ var _TIME_FORMAT_WITH_MIDDAY_FULL = "hh:mm a";
/**
 * @format mm:ss
 * @example 45:59
 **/ var _MINUTES_SECONDS_ONLY = "mm:ss";
/**
 * @format HH:mm
 * @example 08:32
 **/ var _TIME_FORMAT_24 = "HH:mm";
/**
 * @format HH:mm:ss
 * @example 08:32:59
 **/ var _TIME_FORMAT_WITH_SECONDS = "HH:mm:ss";
/**
 * @format LLLL
 * @example June
 **/ var _MONTH_ONLY = "LLLL";
/**
 * @format cccc
 * @example Friday
 **/ var _DAY_NAME_LONG = "cccc";
/**
 * @format d
 * @example 22
 **/ var _DAY_ONLY_NUMBER = "d";
/**
 * @format d LLL
 * @example 7 Dec
 **/ var _SHORT_DAY_AND_MONTH = "d LLL";
/**
 * @format dd/LL/yyyy 'at' hh:mm:ss a
 * @example 22/06/2024 at 08:32:59 AM
 **/ var _DETAILED_DATE_TIME = "dd/LL/yyyy 'at' hh:mm:ss a";
/**
 * @format cccc, LLLL dd, yyyy
 * @example "Tuesday, October 14, 1983"
 **/ var _FULL_DETAILED_DATE = "cccc, LLLL dd, yyyy";
/**
 * @format LLL Do
 * @example June 22
 **/ var _MONTH_DAY = "LLL Do";
/**
 * @format 'Today'
 * @example Today
 **/ var _SAME_DAY_SHORT = "'Today'";
/**
 * @format 'Tomorrow'
 * @example Tomorrow
 **/ var _NEXT_DAY_SHORT = "'Tomorrow'";
/**
 * @format 'Yesterday'
 * @example Yesterday
 **/ var _LAST_DAY_SHORT = "'Yesterday'";
/**
 * @format dd/LL/yyyy
 * @example 22/06/2024
 **/ var _SAME_ELSE_SHORT = "dd/LL/yyyy";
/**
 * @format dddd
 * @example Next Monday
 **/ var _NEXT_WEEK_SHORT = "dddd";
/**
 * @format 'Last' dddd
 * @example Last Monday
 **/ var _LAST_WEEK_SHORT = "'Last' dddd";
/**
 * @format 'Today at' h:mm a
 * @example Today at 8:32 AM
 **/ var _SAME_DAY_LONG = "'Today at' h:mm a";
/**
 * @format 'Tomorrow at' h:mm a
 * @example Tomorrow at 8:32 AM
 **/ var _NEXT_DAY_LONG = "'Tomorrow at' h:mm a";
/**
 * @format dd/LL/yyyy 'at' h:mm a
 * @example 22/06/2024 at 8:32 AM
 **/ var _LAST_DAY_LONG = "dd/LL/yyyy 'at' h:mm a";
/**
 * @format dd/LL/yyyy 'at' h:mm a
 * @example 22/06/2024 at 8:32 AM
 **/ var _SAME_ELSE_LONG = "dd/LL/yyyy 'at' h:mm a";
/**
 * @format dd/LL/yyyy 'at' h:mm a
 * @example 22/06/2024 at 8:32 AM
 **/ var _LAST_WEEK_LONG = "dd/LL/yyyy 'at' h:mm a";
/**
 * @format dd/LL/yyyy 'at' h:mm a
 * @example 22/06/2024 at 8:32 AM
 **/ var _NEXT_WEEK_LONG = "dd/LL/yyyy 'at' h:mm a";
/**
 * @format dd/L/yy
 * @example 22/06/24
 **/ var _DAY_FORMAT_DD_L_YY = "dd/L/yy";
/**
 * @format d/L/yy
 * @example 2/6/24
 **/ var _DAY_FORMAT_D_L_YY = "d/L/yy";
/**
 * @format d/LL/yy
 * @example 2/06/24
 **/ var _DAY_FORMAT_D_LL_YY = "d/LL/yy";
/**
 * @format dd/L/yyyy
 * @example 22/6/2024
 **/ var _DAY_FORMAT_DD_L_YYYY = "dd/L/yyyy";
/**
 * @format d/L/yyyy
 * @example 2/6/2024
 **/ var _DAY_FORMAT_D_L_YYYY = "d/L/yyyy";
/**
 * @format d/LL/yyyy
 * @example 2/06/2024
 **/ var _DAY_FORMAT_D_LL_YYYY = "d/LL/yyyy";
/**
 * @format yy-LL-dd
 * @example 24-06-22
 **/ var _DAY_FORMAT_YY_LL_DD = "yy-LL-dd";
/**
 * @format H:mm
 * @example 8:32
 **/ var _TIME_FORMAT_H_MM = "H:mm";
/**
 * @format H:mm:ss
 * @example 8:32:59
 **/ var _TIME_FORMAT_H_MM_SS = "H:mm:ss";
/**
 * @format h:m:s a
 * @example 8:32:59 AM
 **/ var _TIME_FORMAT_H_M_S_A = "h:m:s a";
/**
 * @format hh mm
 * @example 08 32
 **/ var _TIME_FORMAT_HH_MM = "hh mm";
/**
 * @format hh mm ss
 * @example 08 32 59
 **/ var _TIME_FORMAT_HH_MM_SS = "hh mm ss";
/**
 * @format hh
 * @example 08
 **/ var _TIME_FORMAT_HH = "hh";
/**
 * @format LLL dd, yyyy, hh:mm a;
 * @example Jun 06, 2024, 08:32 am
 **/ var _LONG_DATE_FORMAT_MONTH_AHEAD_CUT = "LLL dd, yyyy, hh:mm a";
/**
 * @format LLLL dd, yyyy, hh:mm a;
 * @example June 06, 2024, 08:32 am
 **/ var _LONG_DATE_FORMAT_MONTH_AHEAD = "LLLL dd, yyyy, hh:mm a";
/**
 * @format LLL dd, yyyy
 * @example June 22, 2020
 **/ var _FULL_MONTH_TEXT_MONTH_AHEAD = "LLL dd, yyyy";
var _ACCEPTED_DAY_FORMATS = {
    /**
   * @format dd/LL/yyyy
   * @example 22/06/2024
   **/ DAY_DEFAULT_FORMAT: _DAY_DEFAULT_FORMAT,
    /**
   * @format d LLL yyyy
   * @example 7 Dec 2018
   **/ DAY_TEXT_MONTH_YEAR_SHORT: _DAY_TEXT_MONTH_YEAR_SHORT,
    /**
   * @format dd LLLL yyyy
   * @example 22nd April 2021
   **/ DAY_TEXT_MONTH_YEAR: _DAY_TEXT_MONTH_YEAR,
    /**
   * @format yyyy-LL-dd
   * @example 2024-06-22
   **/ ISO_DATE: _ISO_DATE,
    /**
   * @format dd/LL/yy
   * @example 22/06/24
   **/ SHORT_YEAR_FORMAT: _SHORT_YEAR_FORMAT,
    /**
   * @format dd/L/yy
   * @example 22/06/24
   **/ DAY_FORMAT_DD_L_YY: _DAY_FORMAT_DD_L_YY,
    /**
   * @format d/L/yy
   * @example 2/6/24
   **/ DAY_FORMAT_D_L_YY: _DAY_FORMAT_D_L_YY,
    /**
   * @format d/LL/yy
   * @example 2/06/24
   **/ DAY_FORMAT_D_LL_YY: _DAY_FORMAT_D_LL_YY,
    /**
   * @format dd/L/yyyy
   * @example 22/6/2024
   **/ DAY_FORMAT_DD_L_YYYY: _DAY_FORMAT_DD_L_YYYY,
    /**
   * @format d/L/yyyy
   * @example 2/6/2024
   **/ DAY_FORMAT_D_L_YYYY: _DAY_FORMAT_D_L_YYYY,
    /**
   * @format d/LL/yyyy
   * @example 2/06/2024
   **/ DAY_FORMAT_D_LL_YYYY: _DAY_FORMAT_D_LL_YYYY,
    /**
   * @format yy-LL-dd
   * @example 24-06-22
   **/ DAY_FORMAT_YY_LL_DD: _DAY_FORMAT_YY_LL_DD,
    /**
   * @format HH:mm
   * @example 08:32
   **/ TIME_FORMAT_24: _TIME_FORMAT_24
};
var _ACCEPTED_TIME_FORMATS = {
    /**
   * @format h:mm a
   * @example 8:32 AM
   **/ DEFAULT_TIME_FORMAT: _DEFAULT_TIME_FORMAT,
    /**
   * @format h:mm:ss a
   * @example 8:32:59 AM
   **/ LONG_TIME_FORMAT: _LONG_TIME_FORMAT,
    /**
   * @format HH:mm
   * @example 08:32
   **/ TIME_FORMAT_24: _TIME_FORMAT_24,
    /**
   * @format HH:mm:ss
   * @example 08:32:59
   **/ TIME_FORMAT_WITH_SECONDS: _TIME_FORMAT_WITH_SECONDS,
    /**
   * @format hh:mm a
   * @example 08:32 AM
   **/ TIME_FORMAT_WITH_MIDDAY_FULL: _TIME_FORMAT_WITH_MIDDAY_FULL,
    /**
   * @format H:mm
   * @example 17:00
   **/ TIME_FORMAT_H_MM: _TIME_FORMAT_H_MM,
    /**
   * @format H:mm:ss
   * @example 17:00:00
   **/ TIME_FORMAT_H_MM_SS: _TIME_FORMAT_H_MM_SS,
    /**
   * @format h:m:s a
   * @example 8:32:59 AM
   **/ TIME_FORMAT_H_M_S_A: _TIME_FORMAT_H_M_S_A,
    /**
   * @format hh mm
   * @example 08 32
   **/ TIME_FORMAT_HH_MM: _TIME_FORMAT_HH_MM,
    /**
   * @format hh mm ss
   * @example 08 32 59
   **/ TIME_FORMAT_HH_MM_SS: _TIME_FORMAT_HH_MM_SS,
    /**
   * @format hh
   * @example 08
   **/ TIME_FORMAT_HH: _TIME_FORMAT_HH
};
var DATE_FORMATS = {
    /**
   * @format yyyy-LL
   * @example 2024-06
   **/ YEAR_MONTH_FORMAT: _YEAR_MONTH_FORMAT,
    /**
   * @format yyyy
   * @example 2024
   **/ YEAR_FORMAT: _YEAR_FORMAT,
    /**
   * @format LLLL yyyy
   * @example June 2024
   **/ MONTH_TEXT_FORMAT: _MONTH_TEXT_FORMAT,
    /**
   * @format dd/LL/yyyy
   * @example 22/06/2024
   **/ DAY_DEFAULT_FORMAT: _DAY_DEFAULT_FORMAT,
    /**
   * @format d LLL yyyy
   * @example 7 Dec 2018
   **/ DAY_TEXT_MONTH_YEAR_SHORT: _DAY_TEXT_MONTH_YEAR_SHORT,
    /**
   * @format ccc, dd/LL/yyyy
   * @example Thu, 22/06/2024
   **/ DAY_FORMAT_WITH_SHORT_DAY_OF_WEEK: _DATE_TIME_FORMAT_WITH_DAY_OF_WEEK,
    /**
   * @format ccc, LL/dd/yyyy, HH:mm a
   * @example Thu, 12/25/2020, 08:32 AM
   **/ FULL_DATE_WEEKDAY_SHORT_MONTH_AHEAD: _FULL_DATE_WEEKDAY_SHORT_MONTH_AHEAD,
    /**
   * @format d LLL yyyy
   * @example 07 Dec 2018
   **/ DAY_TEXT_MONTH_YEAR_SHORT_ALIGN: _DAY_TEXT_MONTH_YEAR_SHORT_ALIGN,
    /**
   * @format yyyyLLddHHmm
   * @example 202406220832
   **/ HL7_RESPONSE_DATE_FORMAT: _HL7_RESPONSE_DATE_FORMAT,
    /**
   * @format yyyyLLdd-hmma
   * @example 20240622-0832am
   **/ TEST_DATE_FORMAT: _TEST_DATE_FORMAT,
    /**
   * @format d LLL yyyy h:mm a
   * @example 7 Dec 2018 8:32 AM
   **/ LONG_DATE_FORMAT: _LONG_DATE_FORMAT,
    /**
   * @format dd/LL/yyyy, h:mm a
   * @example 22/06/2024, 8:32 AM
   **/ LONG_DATE_TIME_FORMAT: _LONG_DATE_TIME_FORMAT,
    /**
   * @format LL/dd/yyyy, h:mm a
   * @example 10/14/1983, 9:30:33 AM
   **/ LONG_DATE_TIME_FORMAT_MONTH_AHEAD: _LONG_DATE_TIME_FORMAT_MONTH_AHEAD,
    /**
   * @format h:mm a dd/LL/yyyy
   * @example 8:32 AM 22/06/2024
   **/ LONG_DATE_TIME_FORMAT_REVERSED: _LONG_DATE_TIME_FORMAT_REVERSED,
    /**
   * @format cccc
   * @example Friday
   **/ DAY_OF_WEEK_STRING: _DAY_OF_WEEK_STRING,
    /**
   * @format ccc dd/LL/yyyy
   * @example Fri 22/06/2024
   **/ LONG_DATE_WITH_DAY: _LONG_DATE_WITH_DAY,
    /**
   * @format ffff
   * @example Friday, June 22, 2024, 8:32 AM
   **/ LOCALIZED_DATE_TIME: _LOCALIZED_DATE_TIME,
    /**
   * @format dd LLLL yyyy
   * @example 22nd April 2021
   **/ DAY_TEXT_MONTH_YEAR: _DAY_TEXT_MONTH_YEAR,
    /**
   * @format dd LLLL
   * @example Thursday 8th July
   **/ LONG_DATE_WITHOUT_TIME: _LONG_DATE_WITHOUT_TIME,
    /**
   * @format LLLL
   * @example June
   **/ MONTH_ONLY: _MONTH_ONLY,
    /**
   * @format cccc
   * @example Friday
   **/ DAY_NAME_LONG: _DAY_NAME_LONG,
    /**
   * @format d
   * @example 22
   **/ DAY_ONLY_NUMBER: _DAY_ONLY_NUMBER,
    /**
   * @format d LLL
   * @example 7 Dec
   **/ SHORT_DAY_AND_MONTH: _SHORT_DAY_AND_MONTH,
    /**
   * @format dd/LL/yyyy 'at' hh:mm:ss a
   * @example 22/06/2024 at 08:32:59 AM
   **/ DETAILED_DATE_TIME: _DETAILED_DATE_TIME,
    /**
   * @format cccc, LLLL dd, yyyy
   * @example "Tuesday, October 14, 1983"
   **/ FULL_DETAILED_DATE: _FULL_DETAILED_DATE,
    /**
   * @format LLL Do
   * @example June 22
   **/ MONTH_DAY: _MONTH_DAY,
    /**
   * @format LLL dd, yyyy, hh:mm a
   * @example Jun 06, 2024, 08:32 am
   **/ LONG_DATE_FORMAT_MONTH_AHEAD_CUT: _LONG_DATE_FORMAT_MONTH_AHEAD_CUT,
    /**
   * @format LLLL dd, yyyy, hh:mm a
   * @example June 06, 2024, 08:32 am
   **/ LONG_DATE_FORMAT_MONTH_AHEAD: _LONG_DATE_FORMAT_MONTH_AHEAD,
    /**
   * @format LLL dd, yyyy
   * @example June 22, 2020
   **/ FULL_MONTH_TEXT_MONTH_AHEAD: _FULL_MONTH_TEXT_MONTH_AHEAD,
    /**
   * @format mm:ss
   * @example 45:59
   **/ MINUTES_SECONDS_ONLY: _MINUTES_SECONDS_ONLY
};
var SHORT_CALENDAR_FORMATS = {
    /**
   * @format 'Today'
   * @example Today
   **/ SAME_DAY: _SAME_DAY_SHORT,
    /**
   * @format 'Tomorrow'
   * @example Tomorrow
   **/ NEXT_DAY: _NEXT_DAY_SHORT,
    /**
   * @format 'Yesterday'
   * @example Yesterday
   **/ LAST_DAY: _LAST_DAY_SHORT,
    /**
   * @format dd/LL/yyyy
   * @example 22/06/2024
   **/ SAME_ELSE: _SAME_ELSE_SHORT,
    /**
   * @format 'Monday'
   * @example Next Monday
   **/ NEXT_WEEK: _NEXT_WEEK_SHORT,
    /**
   * @format 'Last' dddd
   * @example Last Monday
   **/ LAST_WEEK: _LAST_WEEK_SHORT
};
var DEFAULT_CALENDAR_FORMATS = {
    /**
   * @format 'Today at' h:mm a
   * @example Today at 8:32 AM
   **/ SAME_DAY: _SAME_DAY_LONG,
    /**
   * @format 'Tomorrow at' h:mm a
   * @example Tomorrow at 8:32 AM
   **/ NEXT_DAY: _NEXT_DAY_LONG,
    /**
   * @format dd/LL/yyyy 'at' h:mm a
   * @example 22/06/2024 at 8:32 AM
   **/ LAST_DAY: _LAST_DAY_LONG,
    /**
   * @format dd/LL/yyyy 'at' h:mm a
   * @example 22/06/2024 at 8:32 AM
   **/ SAME_ELSE: _SAME_ELSE_LONG,
    /**
   * @format dd/LL/yyyy 'at' h:mm a
   * @example 22/06/2024 at 8:32 AM
   **/ LAST_WEEK: _LAST_WEEK_LONG,
    /**
   * @format dd/LL/yyyy 'at' h:mm a
   * @example 22/06/2024 at 8:32 AM
   **/ NEXT_WEEK: _NEXT_WEEK_LONG
};
var TIME_FORMATS = {
    /**
   * @format h:mm a
   * @example 8:32 AM
   **/ DEFAULT_TIME_FORMAT: _DEFAULT_TIME_FORMAT,
    /**
   * @format hh:mm a
   * @example 08:32 AM
   **/ TIME_FORMAT_WITH_MIDDAY_FULL: _TIME_FORMAT_WITH_MIDDAY_FULL,
    /**
   * @format HH:mm
   * @example 17:00
   **/ TIME_FORMAT_24: _TIME_FORMAT_24,
    /**
   * @format HH:mm:ss
   * @example 17:00:00
   **/ TIME_FORMAT_WITH_SECONDS: _TIME_FORMAT_WITH_SECONDS
};
var ACCEPTED_TIME_FORMATS = Object.values(_ACCEPTED_TIME_FORMATS);
var ACCEPTED_DAY_FORMATS = Object.values(_ACCEPTED_DAY_FORMATS);

var DaySuffixes;
(function(DaySuffixes) {
    DaySuffixes["TH"] = "th";
    DaySuffixes["ST"] = "st";
    DaySuffixes["RD"] = "rd";
    DaySuffixes["ND"] = "nd";
})(DaySuffixes || (DaySuffixes = {}));

var MonthYearRecurrence;
(function(MonthYearRecurrence) {
    MonthYearRecurrence[MonthYearRecurrence["MonthDay"] = 1] = "MonthDay";
    MonthYearRecurrence[MonthYearRecurrence["DayOfWeek"] = 2] = "DayOfWeek";
    MonthYearRecurrence[MonthYearRecurrence["LastDayOfWeek"] = 3] = "LastDayOfWeek";
})(MonthYearRecurrence || (MonthYearRecurrence = {}));

function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
/**
 * Converts a day number to its ordinal representation (1st, 2nd, 3rd, etc.).
 * @param day - The day of the month.
 * @returns The ordinal representation of the day.
 */ var ordinalNumber = function(day) {
    var pluralRules = new Intl.PluralRules("en-US", {
        type: "ordinal"
    });
    var suffixes = new Map([
        [
            "one",
            DaySuffixes.ST
        ],
        [
            "two",
            DaySuffixes.ND
        ],
        [
            "few",
            DaySuffixes.RD
        ],
        [
            "other",
            DaySuffixes.TH
        ]
    ]);
    var rule = pluralRules.select(day);
    var suffix = suffixes.get(rule);
    return "".concat(day).concat(suffix);
};
var timeNames = {
    day: {
        singular: "day",
        plural: "days"
    },
    hour: {
        singular: "hour",
        plural: "hours"
    },
    shortMinute: {
        singular: "min",
        plural: "mins"
    }};
var customFormatDuration = function(duration, isRoundToMinute) {
    var _duration_shiftTo = duration.shiftTo("minutes", "hours", "days"), minutes = _duration_shiftTo.minutes, hours = _duration_shiftTo.hours, days = _duration_shiftTo.days;
    var dayPart = "";
    if (days > 0) {
        dayPart = "".concat(days, " ").concat(days === 1 ? timeNames.day.singular : timeNames.day.plural);
    }
    var hourPart = "";
    if (hours > 0) {
        hourPart = "".concat(hours, " ").concat(hours === 1 ? timeNames.hour.singular : timeNames.hour.plural);
    }
    var minutePart = "";
    if (minutes > 0) {
        minutePart = "".concat(isRoundToMinute ? Math.round(minutes) : minutes, " ").concat(minutes === 1 ? timeNames.shortMinute.singular : timeNames.shortMinute.plural);
    }
    return [
        dayPart,
        hourPart,
        minutePart
    ].filter(function(x) {
        return !!x;
    }).join(" ");
};
var compareDatesPredicate = function(a, b, isSortedDescending) {
    return isSortedDescending ? b.toMillis() - a.toMillis() : a.toMillis() - b.toMillis();
};
var compareDatesOrUndefinedPredicate = function(a, b, isSortedDescending) {
    if (!a) {
        return 1;
    }
    if (!b) {
        return -1;
    }
    var dateA = _instanceof(a, DateTime) ? a : DateTime.fromJSDate(new Date(a));
    var dateB = _instanceof(b, DateTime) ? b : DateTime.fromJSDate(new Date(b));
    return compareDatesPredicate(dateA, dateB, isSortedDescending);
};
var compareISOStrDatesPredicate = function(a, b, isSortedDescending) {
    return compareDatesPredicate(DateTime.fromISOOrNow(a), DateTime.fromISOOrNow(b), isSortedDescending);
};
var getHourAndMinutesFromString$1 = function(time) {
    var timeComponents = (time !== null && time !== void 0 ? time : "").split(":");
    return {
        hour: isNaN(Number(timeComponents[0])) ? 0 : Number(timeComponents[0]),
        minute: isNaN(Number(timeComponents[1])) ? 0 : Number(timeComponents[1])
    };
};
var formatCalendarDate = function(dateTime) {
    var obj = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_CALENDAR_FORMATS;
    var diff = dateTime.diff(DateTime.today(), "days").days;
    if (diff < 6) return dateTime.toFormat(obj["SAME_ELSE"]);
    if (diff < -1) return dateTime.toFormat(obj["LAST_WEEK"]);
    if (diff < 0) return dateTime.toFormat(obj["LAST_DAY"]);
    if (diff < 1) return dateTime.toFormat(obj["SAME_DAY"]);
    if (diff < 2) return dateTime.toFormat(obj["NEXT_DAY"]);
    if (diff < 7) return dateTime.toFormat(obj["NEXT_WEEK"]);
    return dateTime.toFormat(obj["SAME_ELSE"]);
};
/* Don't use this.  You should always know whether you have a string or a JS date
 * This is only here because it was still required for some legacy code that I didn't want to touch when refactoring
 */ var getDateTimeFromISOrJSDate = function(date) {
    return typeof date === "string" ? DateTime.fromISO(date) : DateTime.fromJSDate(date);
};
var getDurationFromMinutes = function(duration) {
    var minutes = duration ? Number(duration) : 0;
    return Duration.fromMillis(minutes * 60 * 1000);
};
var getDayOfWeek = function(date) {
    var weekday = date.weekday;
    return weekday === 7 ? 0 : weekday;
};
var dayOfWeekName = function(dayOfWeek) {
    var mondayIndex = ALL_DAYS_OF_WEEK.indexOf(DaysOfWeek.Monday);
    var index = ALL_DAYS_OF_WEEK.indexOf(dayOfWeek);
    if (index >= 0) {
        var luxonIndex = (index - mondayIndex + 7) % 7; //map from moment/c# day of week where Sunday = 0, to Luxon where 1st DOW Monday
        return Info.weekdays()[luxonIndex];
    }
    return undefined;
};
var isWeekDay = function(dayOfWeek) {
    return dayOfWeek !== DaysOfWeek.Saturday && dayOfWeek !== DaysOfWeek.Sunday;
};
var dayOfMonth = function(date) {
    return ordinalNumber(date.day);
};
var weekOfMonth = function(date) {
    return ordinalNumber(Math.floor(date.day / 7) + 1);
};
/* Returns nth day (Mon, Tue,...) with respective to 1st of the month for the given date. eg. for 12-June-2019, returns 2. i.e., 12-June-2019 is "2nd Wednesday of the Month" */ var nthDayOfMonth = function(date) {
    return Math.floor((date.day - 1) / 7) + 1;
};
/* Returns nth day (Mon, Tue,...) with respective to last(30th/31st/28th/29th) day of the month for the given date. eg. for 12-June-2019, returns 3. i.e., 12-June-2019 is "3rd last Wednesday of the Month" */ var nthLastDayOfMonth = function(date) {
    var lastDayOfMonth = date.endOf("month");
    var diff = lastDayOfMonth.day - date.day;
    return Math.floor(diff / 7) + 1;
};
var getWeekPosition = function(value, monthYearRecurrence) {
    switch(monthYearRecurrence){
        case MonthYearRecurrence.LastDayOfWeek:
            return nthLastDayOfMonth(value) * -1;
        case MonthYearRecurrence.DayOfWeek:
            return nthDayOfMonth(value);
    }
    return undefined;
};
var isToday = function(date) {
    return date.startOf("day").equals(DateTime.today());
};

function _class_call_check$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties$2(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class$2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$2(Constructor, staticProps);
    return Constructor;
}
function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$1(target, key, source[key]);
        });
    }
    return target;
}
var getHourAndMinutesFromString = function(time) {
    var timeComponents = (time !== null && time !== void 0 ? time : "").split(":");
    return {
        hour: isNaN(Number(timeComponents[0])) ? 0 : Number(timeComponents[0]),
        minute: isNaN(Number(timeComponents[1])) ? 0 : Number(timeComponents[1])
    };
};
var INVALID_DATE_FORMAT_ERROR_MESSAGE = "Invalid date format.";
/**
 * A class that does date and time handling, based on Luxon's DateTime.
 * Our wiki has explanations and instructions on using this class at https://dev.azure.com/bpcloud-dev/BpCloud/_wiki/wikis/Bps.Titanium.wiki/693/Dates-in-Omni-front-end
 */ var DateTime = /*#__PURE__*/ function() {
    function DateTime(_dateTime) {
        _class_call_check$2(this, DateTime);
        _define_property$1(this, "_dateTime", void 0);
        this._dateTime = _dateTime;
    }
    _create_class$2(DateTime, [
        {
            key: "isValid",
            get: // INFO
            /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   */ function get() {
                return this._dateTime.isValid;
            }
        },
        {
            key: "year",
            get: /**
   * Get the year
   */ function get() {
                return this._dateTime.year;
            }
        },
        {
            key: "month",
            get: /**
   * Get the month
   */ function get() {
                return this._dateTime.month;
            }
        },
        {
            key: "day",
            get: /**
   * Get the day
   */ function get() {
                return this._dateTime.day;
            }
        },
        {
            key: "hour",
            get: /**
   * Get the hour
   */ function get() {
                return this._dateTime.hour;
            }
        },
        {
            key: "minute",
            get: /**
   * Get the minute
   */ function get() {
                return this._dateTime.minute;
            }
        },
        {
            key: "weekNumber",
            get: /**
   * Get the week number of the week year (1-52ish).
   * @example
   * DateTime.fromISO("2017-05-25").weekNumber //=> 21
   */ function get() {
                return this._dateTime.weekNumber;
            }
        },
        {
            key: "weekday",
            get: /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @example
   * DateTime.fromISO("2014-11-31").weekday //=> 4
   */ function get() {
                return this._dateTime.weekday;
            }
        },
        {
            key: "daysInMonth",
            get: /**
   * Returns the number of days in this DateTime's month
   *
   * @example
   * DateTime.fromISO("2016-02-01").daysInMonth //=> 29
   * */ function get() {
                return this._dateTime.daysInMonth;
            }
        },
        {
            key: "timeZone",
            get: /**
   * Get the time zone associated with this DateTime.
   */ function get() {
                return this._dateTime.zone;
            }
        },
        {
            key: "isYesterday",
            get: /**
   * Returns whether the date is yesterday's date (time doesn't matter)
   */ function get() {
                return this.hasSame(DateTime.now().minus({
                    days: 1
                }), "day");
            }
        },
        {
            key: "isToday",
            get: /**
   * Returns whether the date is today's date (time doesn't matter)
   */ function get() {
                return this.hasSame(DateTime.now(), "day");
            }
        },
        {
            key: "isBeforeToday",
            get: /**
   * Returns whether the date is before today
   */ function get() {
                return DateTime.today() > this.startOf("day");
            }
        },
        {
            // TRANSFORM
            /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime. The returned DateTime will have the same timestamp but different timezone.
   * Eg, 10am AEST would become 12pm NZT.
   * This should only be used in the rare situation where you want to know the difference between the user's timezone and the practice's timezone or if the date
   *
   * @param zone - a zone identifier.
   */ key: "setZone",
            value: function setZone(zone) {
                return new DateTime(this._dateTime.setZone(zone));
            }
        },
        {
            /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   *
   * @param values - a mapping of units to numbers
   *
   * @example
   * dt.set({ year: 2017 })
   * @example
   * dt.set({ hour: 8, minute: 30 })
   * @example
   * dt.set({ weekday: 5 })
   */ key: "set",
            value: function set(values) {
                return new DateTime(this._dateTime.set(values));
            }
        },
        {
            /**
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar,
   * accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   *
   * @param duration - The amount to add
   *
   * @example
   * DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example
   * DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   */ key: "plus",
            value: function plus(duration) {
                return new DateTime(this._dateTime.plus(duration));
            }
        },
        {
            /**
   * The opposite of plus
   *
   * @param duration - The amount to subtract
   */ key: "minus",
            value: function minus(duration) {
                return new DateTime(this._dateTime.minus(duration));
            }
        },
        {
            /**
   * "Set" this DateTime to the beginning of a unit of time.
   *
   * @param unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   *
   * @example
   * DateTime.fromISO("2014-03-03").startOf('month').toISODate(); //=> '2014-03-01'
   */ key: "startOf",
            value: function startOf(unit) {
                return new DateTime(this._dateTime.startOf(unit));
            }
        },
        {
            /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   *
   * @param unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   *
   * @example
   * DateTime.fromISO("2014-03-03").endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   */ key: "endOf",
            value: function endOf(unit) {
                return new DateTime(this._dateTime.endOf(unit));
            }
        },
        {
            // OUTPUT
            /**
   * Returns an ISO string representation of this DateTime.  This should be widely used throughout the app when sending a date + time values to the API - unless only the date is needed then toISODate should be used instead
   *
   * @param opts — options
   * @param opts.suppressMilliseconds — exclude milliseconds from the format if they're 0. Defaults to false.
   * @param opts.suppressSeconds — exclude seconds from the format if they're 0. Defaults to false.
   * @param opts.includeOffset — include the offset, such as 'Z' or '-04:00'. Defaults to true.
   * @param opts.format — choose between the basic and extended format. Defaults to 'extended'.
   *
   * @example
   * DateTime.utc(1982, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example
   * DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example
   * DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example
   * DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   */ key: "toISO",
            value: function toISO(opts) {
                var date = this._dateTime.toISO(opts);
                if (!date) throw new Error(INVALID_DATE_FORMAT_ERROR_MESSAGE);
                return date;
            }
        },
        {
            /**
   * Returns an ISO string representation of this DateTime's date component.  This should be widely used throughout the app when sending date only values to the API
   *
   * @param opts — options
   * @param opts.format — choose between the basic and extended format. Defaults to 'extended'.
   *
   * @example
   * DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example
   * DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   */ key: "toISODate",
            value: function toISODate(opts) {
                var date = this._dateTime.toISODate(opts);
                if (!date) throw new Error(INVALID_DATE_FORMAT_ERROR_MESSAGE);
                return date;
            }
        },
        {
            /**
   * Returns a JavaScript Date equivalent to this DateTime.  JS Dates are primarily used in forms.  If you don't need to use forms or another library that requires JS dates, then it is preferable to keep it as a DateTime.
   * Also note that due to timezone conversions, a JS Date does not have the same timestamp as a DateTime.  This is deliberate.
   */ key: "toJSDate",
            value: function toJSDate() {
                // eslint-disable-next-line no-restricted-syntax
                return new Date(this._dateTime.year, this._dateTime.month - 1, this._dateTime.day, this._dateTime.hour, this._dateTime.minute, this._dateTime.second, this._dateTime.millisecond);
            }
        },
        {
            /**
   * Returns a string in the most common format that a date should be displayed in Omni - 21/03/2023
   * This method is a shortcut for dateTime.toFormat(DateFormats.dayDefaultFormat)
   */ key: "toDayDefaultFormat",
            value: function toDayDefaultFormat() {
                return this.toFormat(DATE_FORMATS.DAY_DEFAULT_FORMAT);
            }
        },
        {
            /**
   * Converts the hours and days into a string so that it can be used in a time picker input - 23:15
   * This method is a shortcut for dateTime.toFormat(TimeFormats.timeFormat24)
   */ key: "toTimeInputFormat",
            value: function toTimeInputFormat() {
                return this.toFormat(TIME_FORMATS.TIME_FORMAT_24);
            }
        },
        {
            /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * For a table of tokens and their interpretations see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   *
   * @param fmt - the format string
   *
   * @example
   * DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example
   * DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   */ key: "toFormat",
            value: function toFormat(fmt) {
                var _this = this;
                var fmtWithoutDo = fmt.replace(/Do/g, "[__]");
                var result = this._dateTime.toFormat(fmtWithoutDo, {
                    locale: "en-AU"
                });
                return result.replace(/\[__\]/g, function() {
                    return ordinalNumber(_this.day);
                });
            }
        },
        {
            /**
   * Returns a string representation of this DateTime.  This is just for debugging - don't directly call this.
   */ key: "toString",
            value: function toString() {
                return this._dateTime.toString();
            }
        },
        {
            /**
   * Required for comparing two dates using < or >.  Don't directly call this.
   * There may be a slight difference between this and toMillis as this is because this needs to allow comparisons with JS dates - not that we should.
   */ key: "valueOf",
            value: function valueOf() {
                return this.toJSDate().getTime();
            }
        },
        {
            /**
   * Returns the milliseconds of this DateTime since 1970.  This shouldn't be widely used.  Use <, >, and .equals to compare dates instead.
   */ key: "toMillis",
            value: function toMillis() {
                return this._dateTime.toMillis();
            }
        },
        {
            /**
   * Return a human-readable string representing the relative time from now to the DateTime instance.
   * @example
   * DateTime.now().plus({ days: 1 }).toRelative(); //=> "in 1 day"
   * @example
   * DateTime.now().minus({ hours: 3 }).toRelative(); //=> "3 hours ago"
   */ key: "toRelative",
            value: function toRelative() {
                var _this__dateTime_toRelative;
                return (_this__dateTime_toRelative = this._dateTime.toRelative()) !== null && _this__dateTime_toRelative !== void 0 ? _this__dateTime_toRelative : undefined;
            }
        },
        {
            // COMPARE
            /**
   * Return the difference between two DateTimes as a Duration.
   *
   * @param otherDateTime - the DateTime to compare this one to
   * @param unit- the unit or array of units (such as 'hours' or 'days') to include in the duration. Defaults to ['milliseconds'].

   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   */ key: "diff",
            value: function diff(otherDateTime, unit) {
                return this._dateTime.diff(otherDateTime._dateTime, unit);
            }
        },
        {
            /**
   * Return whether this DateTime is in the same unit of time as another DateTime.

   * @param otherDateTime - the other DateTime
   * @param unit - the unit of time to check sameness on
   *
   * @example
   * DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   */ key: "hasSame",
            value: function hasSame(otherDateTime, unit) {
                return this._dateTime.hasSame(otherDateTime._dateTime, unit);
            }
        },
        {
            /**
   * Equality check (note that we cannot compare using === because that will always return false). Two DateTimes are equal if they represent the same millisecond and are both valid.
   *
   * @param other - the other DateTime
   */ key: "equals",
            value: function equals(other) {
                return this._dateTime.equals(other._dateTime);
            }
        },
        {
            /**
   * Checks whether the DateTime is between two other DateTimes.  This includes if it matches either time exactly (to the millisecond)
   *
   * @param from the earlier other DateTime
   * @param to the later other DateTime
   */ key: "isBetweenInclusive",
            value: function isBetweenInclusive(from, to) {
                return this.valueOf() >= from.valueOf() && this.valueOf() <= to.valueOf();
            }
        }
    ], [
        {
            key: "now",
            value: /**
   * Create a DateTime for the current instant in the practice timezone.  This is the DateTime equivalent of new Date().
   */ function now() {
                return new DateTime(DateTime$1.now());
            }
        },
        {
            key: "today",
            value: /**
   * Create a DateTime for the current day in the practice timezone with a time of midnight
   */ function today() {
                return DateTime.now().startOf("day");
            }
        },
        {
            key: "tomorrow",
            value: /**
   * Create a DateTime for the current day in the practice timezone with a time of midnight tomorrow
   */ function tomorrow() {
                return DateTime.now().plus({
                    days: 1
                }).startOf("day");
            }
        },
        {
            key: "fromISO",
            value: function fromISO(text, opts) {
                if (text === undefined) return undefined;
                return new DateTime(DateTime$1.fromISO(text, opts));
            }
        },
        {
            key: "fromISOOrNow",
            value: /**
   * Create a DateTime from an ISO string or defaults to the current instant if the string is empty.
   * This method is a shortcut for DateTime.from(str) || DateTime.now()
   *
   * @param text - the ISO string or undefined
   */ function fromISOOrNow(date, opts) {
                return DateTime.fromISO(date, opts) || DateTime.now();
            }
        },
        {
            key: "fromJSDate",
            value: function fromJSDate(date) {
                if (!date) return undefined;
                if (isNaN(Number(date))) {
                    return new DateTime(DateTime$1.fromISO("Invalid date"));
                }
                return new DateTime(DateTime$1.fromObject({
                    year: date.getFullYear(),
                    month: date.getMonth() + 1,
                    day: date.getDate(),
                    hour: date.getHours(),
                    minute: date.getMinutes(),
                    second: date.getSeconds(),
                    millisecond: date.getMilliseconds()
                }));
            }
        },
        {
            key: "fromJSDateOrNow",
            value: /**
   * Same as fromJSDate but it defaults to the current instant if the string is empty.
   * This method is a shortcut for DateTime.fromJSDate(str) || DateTime.now()
   *
   * @param date - a JavaScript Date object or undefined
   */ function fromJSDateOrNow(date) {
                return DateTime.fromJSDate(date) || DateTime.now();
            }
        },
        {
            key: "fromObject",
            value: /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour'.
   *
   * @param obj - the object to create the DateTime from
   * @example
   * DateTime.fromObject({ year: 1982, month: 5, day: 25, hour: 10, minute: 30 })
   */ function fromObject(obj) {
                return new DateTime(DateTime$1.fromObject(obj));
            }
        },
        {
            key: "fromMillis",
            value: /**
   * Create a DateTime from a number of milliseconds since 1970 UTC. This should not need to be commonly used.  If you are tempted to use this method to help compare dates, check out .equals, .hasSame or existing utils.
   *
   * @param milliseconds - a number of milliseconds
   */ function fromMillis(milliseconds) {
                return new DateTime(DateTime$1.fromMillis(milliseconds));
            }
        },
        {
            key: "fromJSDateAndTime",
            value: /**
   * Create a DateTime from a Date object and a time string.  This is relevant for when date and time have different fields in a form and on submit they need to be recombined.
   *
   * @param date - the date as an ISO string
   * @param time - the time as a string
   * @example
   * DateTime.fromJSDateAndTime(DateTime.jsNow(), '10:22')
   */ function fromJSDateAndTime(date, time) {
                return DateTime.fromObject(_object_spread({
                    year: date.getFullYear(),
                    month: date.getMonth() + 1,
                    day: date.getDate()
                }, getHourAndMinutesFromString(time)));
            }
        },
        {
            key: "fromISODateAndTime",
            value: /**
   * Create a DateTime from a date string (in ISO format) and a time string.  This is relevant for situations where the date and time are stored separately on a dto.  It is not intended to be used to get values from forms - use fromJSDateandTime instead.
   *
   * @param date - the date as an ISO string
   * @param time - the time as a string
   * @example
   * DateTime.fromISODateAndTime('2016-05-25', '10:22')
   */ function fromISODateAndTime(date, time, opts) {
                var dateTime = DateTime.fromISO(date, opts);
                return DateTime.fromObject(_object_spread({
                    year: dateTime.year,
                    month: dateTime.month,
                    day: dateTime.day
                }, getHourAndMinutesFromString(time)));
            }
        },
        {
            key: "fromParsedTimeString",
            value: /**
   * Create a DateTime from a time string.  This can be useful to process values from a time picker field in a form.  it will return undefined if the string does not parse correctly.
   *
   * @param time - the string to parse
   * @example
   * DateTime.fromParsedTimeString('10:22') // 10:22 am
   * @example
   * DateTime.fromParsedTimeString('10:22:01') // 10:22 am + 1 second
   * @example
   * DateTime.fromParsedTimeString('10:22 am') // 10:22 am
   * @example
   * DateTime.fromParsedTimeString('22:10') // 10:10 pm
   */ function fromParsedTimeString(time) {
                if (!time) return undefined;
                for(var i = 0; i < ACCEPTED_TIME_FORMATS.length; i++){
                    var dateTime = DateTime.fromFormat(time, ACCEPTED_TIME_FORMATS[i]);
                    if (dateTime.isValid) {
                        return dateTime;
                    }
                }
                return undefined;
            }
        },
        {
            key: "fromFormat",
            value: /**
   * Create a DateTime from an input string and format string.  This method should not need to be widely used because all dates should be able to be created using another existing method.
   * Import DateFormats or TimeFormats from common/DateTime for commonly used formats.
   *
   * @param text - the string to parse
   * @param fmt - the format the string is expected to be in
   */ function fromFormat(text, fmt) {
                return new DateTime(DateTime$1.fromFormat(text, fmt));
            }
        },
        {
            key: "jsDateNow",
            value: // JS DATE CONVERSIONS
            // Often we will need to use JS dates in forms and other components.  The following functions make the conversions a bit simpler for developers
            /**
   * Creates a new JS date of the current instance.  This is the literal equivalent of new Date() but it is created through our DateTime to ensure it has the correct timezone.
   * This is a shortcut for DateTime.now().toJSDate().
   */ function jsDateNow() {
                return DateTime.now().toJSDate();
            }
        },
        {
            key: "jsDateFromISO",
            value: function jsDateFromISO(str) {
                if (str === undefined) return undefined;
                return DateTime.fromISO(str).toJSDate();
            }
        },
        {
            key: "jsDateToISODate",
            value: function jsDateToISODate(date) {
                if (date === undefined) return undefined;
                var _DateTime_fromJSDate_toISODate;
                return (_DateTime_fromJSDate_toISODate = DateTime.fromJSDate(date).toISODate()) !== null && _DateTime_fromJSDate_toISODate !== void 0 ? _DateTime_fromJSDate_toISODate : undefined;
            }
        }
    ]);
    return DateTime;
}();

function _class_call_check$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties$1(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Interval = /*#__PURE__*/ function() {
    function Interval(_interval) {
        _class_call_check$1(this, Interval);
        _define_property(this, "_interval", void 0);
        this._interval = _interval;
    }
    _create_class$1(Interval, [
        {
            key: "start",
            get: function get() {
                return new DateTime(this._interval.start);
            }
        },
        {
            key: "splitBy",
            value: function splitBy(duration) {
                return this._interval.splitBy(duration).map(function(interval) {
                    return new Interval(interval);
                });
            }
        }
    ], [
        {
            key: "fromDateTimes",
            value: function fromDateTimes(start, end) {
                return new Interval(Interval$1.fromDateTimes(start._dateTime, end._dateTime));
            }
        }
    ]);
    return Interval;
}();

function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var DateInfo = /*#__PURE__*/ function() {
    function DateInfo() {
        _class_call_check(this, DateInfo);
    }
    _create_class(DateInfo, null, [
        {
            key: "months",
            value: /**
   * Get the list of month names.
   *
   * @param length - The length of the month names ('narrow', 'short', or 'long').
   * @param options - Options to customize the output.
   * @returns An array of month names.
   */ function months(length, options) {
                return Info.months(length, options);
            }
        },
        {
            key: "weekdays",
            value: /**
   * Get the list of weekday names.
   *
   * @param length - The length of the weekday names ('narrow', 'short', or 'long').
   * @param options - Options to customize the output.
   * @returns An array of weekday names.
   */ function weekdays(length, options) {
                return Info.weekdays(length, options);
            }
        }
    ]);
    return DateInfo;
}();

export { ACCEPTED_DAY_FORMATS, ACCEPTED_TIME_FORMATS, ALL_DAYS_OF_WEEK, DATE_FORMATS, DEFAULT_CALENDAR_FORMATS, DateInfo, DateSettings, DateTime, DaysOfWeek, Interval, MAXIMUM_DATE_MILLISECOND, MonthYearRecurrence, SHORT_CALENDAR_FORMATS, TIME_FORMATS, compareDatesOrUndefinedPredicate, compareDatesPredicate, compareISOStrDatesPredicate, customFormatDuration, dayOfMonth, dayOfWeekName, formatCalendarDate, getDateTimeFromISOrJSDate, getDayOfWeek, getDurationFromMinutes, getHourAndMinutesFromString$1 as getHourAndMinutesFromString, getWeekPosition, isToday, isWeekDay, nthDayOfMonth, nthLastDayOfMonth, ordinalNumber, weekOfMonth };
